import { useDispatch } from "react-redux";
import { useCallback } from "react";

import useShallowSelector from "./useShalowSelector";
import { selectUISideBar } from "../store/ui/selectors";
import { changeSideBar } from "../store/ui/actionCreators";

export interface onToggle {
    (): void;
}

type UseSideBar = () => {
    isOpen: boolean;
    onToggle: onToggle;
};

const useSideBar: UseSideBar = () => {
    const { isOpen } = useShallowSelector(selectUISideBar);

    const dispatch = useDispatch();

    const onToggle: onToggle = useCallback(() => {
        dispatch(changeSideBar({ isOpen: !isOpen }));
    }, [dispatch, isOpen]);

    return { isOpen, onToggle };
};

export default useSideBar;
